import { BasePage } from '@/components/ui/base-page'

export function EquityInsurancePage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add EquityInsurancePage specific content here */}
    </BasePage>
  )
}